/* this file is transformed by vux-loader */
/* eslint-disable */
export var box = {
  show: true,
  items: []
};